import {useEffect, useState} from "react";
import {getAppZoom} from "../helpers/screenScale";

export const useScreenScale = () => {
    const [scale, setScale] = useState(1);
    const scaleFactor = 850;

    useEffect(() => {
        // Use the layout height so this doesn't shrink on top of the automatic screen scale.
        setScale(window.innerHeight / getAppZoom() / scaleFactor);
    }, [window.innerHeight])

    return {scale};
}
